import { createSlice } from "@reduxjs/toolkit";
import { initialStatePhone, RoleStatus } from "../constants.ts";
import { fetchPhoneRoles } from "../api.ts";

const initialState = initialStatePhone;
export const phoneRolesSlice = createSlice({
  name: "phone",
  initialState,
  reducers: {
    prevPage: (state) => {
      if (state.currentPage > 1) state.currentPage = state.currentPage - 1;
    },
    nextPage: (state) => {
      if (state.next) state.currentPage = state.currentPage + 1;
    },
    setPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setPageSize: (state, action) => {
      state.pageSize = action.payload;
    },
    setStatus: (state, action) => {
      state.status = action.payload;
    },
    setSort: (state, action) => {
      state.sortBy = action.payload;
    },
    setSearch: (state, action) => {
      state.search = action.payload ?? "";
    },
    setSubcompanyId: (state, action) => {
      state.subcompany_id = action.payload ?? null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPhoneRoles.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchPhoneRoles.fulfilled, (state, action) => {
        state.loading = false;
        if (state.status == RoleStatus.All)
          state.data.all = action.payload?.results;
        else if (state.status == RoleStatus.Active)
          state.data.active = action.payload?.results;
        else if (state.status == RoleStatus.Inactive)
          state.data.inactive = action.payload?.results;
        state.count = action?.payload.count;
        state.next = action?.payload.next;
        state.prev = action?.payload.prev;
      })
      .addCase(fetchPhoneRoles.rejected, (state, action) => {
        state.loading = false;
        state.error = (action.error as string) || "Error found";
      });
  },
});

export const { prevPage, nextPage, setPage, setPageSize, setStatus, setSort, setSearch, setSubcompanyId } =
  phoneRolesSlice.actions;

export default phoneRolesSlice.reducer;
